var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMessageicon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.024 9.08087L16.3367 13.6599C15.2605 14.5037 13.7517 14.5037 12.6754 13.6599L6.93933 9.08087",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18415 1.66602H20.7547C22.5672 1.68634 24.2924 2.45259 25.5283 3.78629C26.7643 5.11998 27.4032 6.90472 27.2963 8.72484V17.4287C27.4032 19.2488 26.7643 21.0335 25.5283 22.3672C24.2924 23.7009 22.5672 24.4672 20.7547 24.4875H8.18415C4.29094 24.4875 1.66699 21.3202 1.66699 17.4287V8.72484C1.66699 4.83328 4.29094 1.66602 8.18415 1.66602Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 26,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessageicon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Messageicon.3b261485.svg";
export { ForwardRef as ReactComponent };